var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"navbarTitle":"","mainFixed":false}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mb-4 p-2"},[_c('Events')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }